import type { AdvancedFilter as AdvancedFilterQuery } from '@packages/schemas';
import { Form, Switch, Tooltip } from 'antd';
import { PatientFiltersPanel } from '@ui/features/PatientFilters/components/PatientsFilterPanel';

interface PatientFilterPanelWrapperProps {
    hidden?: boolean;
    messageId?: string | null;
}

export default function PatientFilterPanelWrapper({ hidden, messageId }: PatientFilterPanelWrapperProps) {
    const esOmopSwitchSlot = (
        <div className="flex w-full items-center justify-between">
            <Tooltip title="When on, filters also search the Bronze layer (raw/NLP data) for diagnosis, procedures, medication, and patient ID. Turn off to use only Silver (OMOP) data.">
                <span className="cursor-pointer text-xs text-[#656565]">Include Bronze (Raw/NLP) data matches</span>
            </Tooltip>
            <Form.Item
                name="includeElasticsearchForFilters"
                valuePropName="checked"
                initialValue={false}
                className="mb-0!"
            >
                <Switch
                    checkedChildren="Silver + Bronze"
                    unCheckedChildren="Silver"
                />
            </Form.Item>
        </div>
    );

    return (
        <Form.Item
            name="patientAdvancedFilter"
            className="mb-0!"
        >
            <PatientFilterPanel
                hidden={hidden}
                messageId={messageId}
                slotAfterToolbar={!messageId ? esOmopSwitchSlot : null}
            />
        </Form.Item>
    );
}

interface PatientFilterPanelProps {
    value?: AdvancedFilterQuery;
    onChange?: (value?: AdvancedFilterQuery) => void;
    hidden?: boolean;
    messageId?: string | null;
    slotAfterToolbar?: React.ReactNode;
}

function PatientFilterPanel({ value, onChange, hidden, messageId, slotAfterToolbar }: PatientFilterPanelProps) {
    if (hidden) {
        return null;
    }

    return (
        <PatientFiltersPanel
            value={value}
            onAdvancedFiltersChange={onChange}
            messageId={messageId}
            slotAfterToolbar={slotAfterToolbar}
        />
    );
}
